import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetOpenSOListByStore,
  GetPartInvById,
  deleteKitbyId,
  getBOMAltbyPartStore,
  getBOMbyPartStore,
  getKitPartbyId,
  getKitbyId,
  saveKit,
} from "../../api";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Header } from "../../components";
import { validateField } from "../../contexts/Utils";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import SelectField from "../../components/SelectField";
import DoubleField from "../../components/DoubleField";
import DateInputField from "../../components/DateInputField";

const AddEditKit = () => {
  const navigate = useNavigate();
  const { currentColor, userID, storeG } = useStateContext();
  let param = useParams();
  const Part_id = param.p_id || 0;
  const [status, setStatus] = useState("Pending");
  const [statusId, setStatusId] = useState(1600);
  const [itemList, setItemList] = useState([]);
  const [altItemList, setAltItemList] = useState([]);
  const [soIds, setSoIds] = useState([]);
  const [rowId, setRowId] = useState(null);

  const [formData, setFormData] = useState({
    so: "select",
    notes: "",
    kit_qty: "0",
    overage: "0.00",
    calc_qty: 0,
    t_cost: 0,
    c_cost: 0,
  });
  const [partData, setPartData] = useState({
    part_id: 0,
    part_number: "",
    description: "",
    stock: 0,
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState([]);
  const [loadBtn, setLoadBtn] = useState(false);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["use_alt"].includes(name)) {
      const index = parseInt(e.target.getAttribute("data-index"));
      let alt_id = 0;
      let alt_use = false;
      let kcost = 0,
        ccost = 0;
      const qtyy = formData.calc_qty;
      const updList = itemList.map((item, i) => {
        if (i !== index) {
          const kQty1 =
            item.dni || item.use_alt ? 0 : Math.ceil(item.quantity * qtyy);
          kcost += item.cost_price * kQty1;
          ccost +=
            item.cost_price *
            (kQty1 - item.instock > 0 ? kQty1 - item.instock : 0);
          return item;
        }
        alt_id = item.alt_part_id;
        alt_use = !item.use_alt;
        const kQty = item.dni || alt_use ? 0 : Math.ceil(item.quantity * qtyy);
        kcost += item.cost_price * kQty;
        ccost +=
          item.cost_price * (kQty - item.instock > 0 ? kQty - item.instock : 0);
        return {
          ...item,
          use_alt: alt_use,
          for_kit: kQty,
          for_kit_cost: formatCurrency(item.cost_price * kQty),
          short: item.stock - kQty < 0 ? item.stock - kQty : 0,
          after_kit: item.stock - kQty >= 0 ? item.stock - kQty : 0,
        };
      });
      setItemList(updList);
      const updAltList = altItemList.map((item, i) => {
        if (item.part_id !== alt_id) {
          const kQty1 = !item.use_alt ? 0 : Math.ceil(item.quantity * qtyy);
          kcost += item.cost_price * Math.ceil(item.quantity * qtyy);
          ccost +=
            item.cost_price *
            (kQty1 - item.instock > 0 ? kQty1 - item.instock : 0);
          return item;
        }
        const kQty = !alt_use ? 0 : Math.ceil(item.quantity * qtyy);
        kcost += item.cost_price * kQty;
        ccost +=
          item.cost_price * (kQty - item.instock > 0 ? kQty - item.instock : 0);
        return {
          ...item,
          use_alt: alt_use,
          for_kit: kQty,
          for_kit_cost: formatCurrency(item.cost_price * kQty),
          short: item.stock - kQty < 0 ? item.stock - kQty : 0,
          after_kit: item.stock - kQty >= 0 ? item.stock - kQty : 0,
        };
      });
      setAltItemList(updAltList);
      setFormData((prev) => ({ ...prev, t_cost: kcost, c_cost: ccost }));
    } else if (["new_issue"].includes(name)) {
      const index = parseInt(e.target.getAttribute("data-index"));
      setItemList((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;
          return { ...item, [name]: value };
        }),
      );
    } else if (["alt_new_issue"].includes(name)) {
      const index = parseInt(e.target.getAttribute("data-index"));
      setAltItemList((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;
          return { ...item, [name]: value };
        }),
      );
    } else setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "kit_qty")
      updateTable(parseFloat(value), parseFloat(formData.overage));
    if (name === "overage")
      updateTable(parseFloat(formData.kit_qty), parseFloat(value));

    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const rowSelected = (item) => {
    if (rowId === item) setRowId(null);
    else setRowId(item);
  };

  const updateTable = (qty, ovr) => {
    qty += (qty * ovr) / 100;
    let kcost = 0,
      ccost = 0;
    const updList = itemList.map((item) => {
      const kQty =
        item.dni || item.use_alt ? 0 : Math.ceil(item.quantity * qty) || 0;
      kcost += item.cost_price * kQty;
      ccost +=
        item.cost_price * (kQty - item.instock > 0 ? kQty - item.instock : 0);
      return {
        ...item,
        for_kit: kQty,
        for_kit_cost: formatCurrency(item.cost_price * kQty),
        short: item.stock - kQty < 0 ? item.stock - kQty : 0,
        after_kit: item.stock - kQty >= 0 ? item.stock - kQty : 0,
      };
    });
    setItemList(updList);
    const altList = altItemList.map((item) => {
      const kQty = !item.use_alt ? 0 : Math.ceil(item.quantity * qty) || 0;
      kcost += item.cost_price * kQty;
      ccost +=
        item.cost_price * (kQty - item.instock > 0 ? kQty - item.instock : 0);
      return {
        ...item,
        for_kit: kQty,
        for_kit_cost: formatCurrency(item.cost_price * kQty),
        short: item.stock - kQty < 0 ? item.stock - kQty : 0,
        after_kit: item.stock - kQty >= 0 ? item.stock - kQty : 0,
      };
    });
    setAltItemList(altList);
    setFormData((prev) => ({
      ...prev,
      calc_qty: qty,
      t_cost: kcost,
      c_cost: ccost,
    }));
  };

  const handleAddcartClick = () => {
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(partData).forEach((key) => {
      const error = validateField(key, partData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  };

  const handleFillClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "so") {
        const error = validateField(key, formData[key], key);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }

    const updList = itemList.map((item) => {
      return { ...item, new_issue: item.for_kit };
    });
    setItemList(updList);
    const altList = altItemList.map((item) => {
      return { ...item, alt_new_issue: item.for_kit };
    });
    setAltItemList(altList);
  };

  const handleSaveClick = async (e, type) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "so") {
        const error = validateField(key, formData[key], key);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    if (
      !window.confirm(
        `Are you sure you want to ${type === "Save" ? `save` : `pull`} this kit?`,
      )
    ) {
      setLoadBtn(false);
      return;
    }
    try {
      const kitId = Part_id >= 10000000 ? 0 : Part_id || 0;
      const kitParts = itemList.map((item, i) => ({
        kit_id: kitId,
        item_no: i + 1,
        part_id: item.part_id,
        quantity: parseFloat(item.quantity) || 0,
        ext_quantity: parseFloat(item.for_kit) || 0,
        act_quantity:
          parseFloat(item.issued_qty) + parseFloat(item.new_issue) || 0,
        stock_before: parseFloat(item.instock) || 0,
        stock_after: parseFloat(item.after_kit) || 0,
        use_alternate: item.use_alt || false,
      }));
      const kitAltParts = altItemList.map((item, i) => ({
        kit_id: kitId,
        item_no: i + 10001,
        part_id: item.part_id,
        quantity: parseFloat(item.quantity) || 0,
        ext_quantity: parseFloat(item.for_kit) || 0,
        act_quantity:
          parseFloat(item.issued_qty) + parseFloat(item.alt_new_issue) || 0,
        stock_before: parseFloat(item.instock) || 0,
        stock_after: parseFloat(item.after_kit) || 0,
        use_alternate: item.use_alt || false,
      }));
      const kitData = {
        store_id: storeG?.store_id,
        date: oDatetime || null,
        kit_status_id: type === "Pull" ? 1601 : statusId,
        so_id: formData.so !== "select" ? formData.so.value : null,
        top_part_id: partData.part_id,
        kit_quantity: parseFloat(formData.kit_qty),
        overage: parseFloat(formData.overage),
        complete_date: null,
        notes: formData.notes,
        user_id: userID,
        kit_parts: kitParts,
        kit_alt_parts: kitAltParts,
      };
      const response = await saveKit(kitId, kitData);
      if (response.success) {
        showSuccessToast("Success!", "Kit saved successfully.");
        navigate("/Kit");
      } else
        showErrorToast("Error!", "Kit failed to save!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Kit failed to save!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleIssueClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "so") {
        const error = validateField(key, formData[key], key);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    let pns = [];
    let pn2 = [];
    itemList.forEach((item) => {
      if (item.stock < parseFloat(item.new_issue)) pns.push(item.part_number);
      if (item.for_kit > parseFloat(item.new_issue)) pn2.push(item.part_number);
    });
    if (pns.length > 0) {
      showErrorToast(
        "Error!",
        `Stock After Kit cannot be < 0 for any part.\nThis kit has ${pns.length} Part(s) < 0:\n[${pns.join(", ")}]`,
      );
      setLoadBtn(false);
      return;
    }
    pns = [];
    altItemList.forEach((item) => {
      if (item.stock < parseFloat(item.alt_new_issue))
        pns.push(item.part_number);
      if (item.for_kit > parseFloat(item.alt_new_issue))
        pn2.push(item.part_number);
    });
    if (pns.length > 0) {
      showErrorToast(
        "Error!",
        `Stock After Kit cannot be < 0 for any part.\nThis kit has ${pns.length} Alternate Part(s) < 0:\n[${pns.join(", ")}]`,
      );
      setLoadBtn(false);
      return;
    }
    if (
      (pn2.length > 0 &&
        !window.confirm(
          `This kit has ${pn2.length} shortages:\n[${pn2.join(", ")}]\n\nAre you sure you want to Issue this kit?`,
        )) ||
      !window.confirm(
        `By Issuing this kit all 'New Issue' will be subtracted from Stock. This can't be undone.\nDo you wish to continue?`,
      )
    ) {
      setLoadBtn(false);
      return;
    }
    try {
      const kitId = Part_id >= 10000000 ? 0 : Part_id || 0;
      const kitParts = itemList.map((item, i) => ({
        kit_id: kitId,
        item_no: item.item_no,
        part_id: item.part_id,
        quantity: parseFloat(item.quantity) || 0,
        ext_quantity: parseFloat(item.for_kit) || 0,
        act_quantity:
          parseFloat(item.issued_qty) + parseFloat(item.new_issue) || 0,
        stock_before: parseFloat(item.instock) || 0,
        stock_after: parseFloat(item.after_kit) || 0,
        use_alternate: item.use_alt || false,
      }));
      const kitAltParts = altItemList.map((item, i) => ({
        kit_id: kitId,
        item_no: item.item_no,
        part_id: item.part_id,
        quantity: parseFloat(item.quantity) || 0,
        ext_quantity: parseFloat(item.for_kit) || 0,
        act_quantity:
          parseFloat(item.issued_qty) + parseFloat(item.alt_new_issue) || 0,
        stock_before: parseFloat(item.instock) || 0,
        stock_after: parseFloat(item.after_kit) || 0,
        use_alternate: item.use_alt || false,
      }));
      const kitData = {
        store_id: storeG?.store_id,
        date: oDatetime || null,
        kit_status_id: pn2.length > 0 ? 1602 : 1603,
        so_id: formData.so !== "select" ? formData.so.value : null,
        top_part_id: partData.part_id,
        kit_quantity: parseFloat(formData.kit_qty),
        overage: parseFloat(formData.overage),
        complete_date: null,
        notes: formData.notes,
        user_id: userID,
        kit_parts: kitParts,
        kit_alt_parts: kitAltParts,
      };
      const response = await saveKit(kitId, kitData);
      if (response.success) {
        showSuccessToast(
          "Success!",
          `Kit Issued Successfully with Status: Issued - ${pn2.length > 0 ? "Partial" : "Waiting Completion"}`,
        );
        navigate("/Kit");
      } else
        showErrorToast("Error!", "Kit failed to issue!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Kit failed to issue!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleIssueItemClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    if (rowId === null) {
      showInfoToast("Info!", `Select a Part to Proceed!`);
      setLoadBtn(false);
      return;
    }
    const altt = altItemList.some((item) => item === rowId);
    if (rowId.dni) {
      showErrorToast("Error!", `Selected Part is DNI and cannot be issued!`);
      setLoadBtn(false);
      return;
    }
    if ((!altt && rowId.new_issue <= 0) || (altt && rowId.alt_new_issue <= 0)) {
      showErrorToast(
        "Error!",
        `Selected Part has zero New Issue and cannot be issued!`,
      );
      setLoadBtn(false);
      return;
    }

    let pns = [];
    let pn2 = [];
    itemList.forEach((item) => {
      if (item.stock < parseFloat(item.new_issue)) pns.push(item.part_number);
      if (item !== rowId && item.short < 0) pn2.push(item.part_number);
      if (item === rowId && item.short + item.new_issue < 0)
        pn2.push(item.part_number);
    });
    if (pns.length > 0) {
      showErrorToast(
        "Error!",
        `Stock After Kit cannot be < 0 for any part.\nThis kit has ${pns.length} Part(s) < 0:\n[${pns.join(", ")}]`,
      );
      setLoadBtn(false);
      return;
    }
    pns = [];
    altItemList.forEach((item) => {
      if (item.stock < parseFloat(item.alt_new_issue))
        pns.push(item.part_number);
      if (item !== rowId && item.short < 0) pn2.push(item.part_number);
      if (item === rowId && item.short + item.new_issue < 0)
        pn2.push(item.part_number);
    });
    if (pns.length > 0) {
      showErrorToast(
        "Error!",
        `Stock After Kit cannot be < 0 for any part.\nThis kit has ${pns.length} Alternate Part(s) < 0:\n[${pns.join(", ")}]`,
      );
      setLoadBtn(false);
      return;
    }
    if (
      !window.confirm(
        `By Issuing this kit item the 'New Issue' for selected item will be subtracted from Stock. This can't be undone.\nDo you wish to continue and save all the other information too?`,
      )
    ) {
      setLoadBtn(false);
      return;
    }
    try {
      const kitId = Part_id >= 10000000 ? 0 : Part_id || 0;
      const kitParts = itemList
        .filter((item) => item === rowId)
        .map((item) => ({
          kit_id: kitId,
          item_no: item.item_no,
          part_id: item.part_id,
          quantity: parseFloat(item.quantity) || 0,
          ext_quantity: parseFloat(item.for_kit) || 0,
          act_quantity:
            parseFloat(item.issued_qty) + parseFloat(item.new_issue) || 0,
          stock_before: parseFloat(item.instock) || 0,
          stock_after: parseFloat(item.after_kit) || 0,
          use_alternate: item.use_alt || false,
        }));
      const kitAltParts = altItemList
        .filter((item) => item === rowId)
        .map((item) => ({
          kit_id: kitId,
          item_no: item.item_no + 10000,
          part_id: item.part_id,
          quantity: parseFloat(item.quantity) || 0,
          ext_quantity: parseFloat(item.for_kit) || 0,
          act_quantity:
            parseFloat(item.issued_qty) + parseFloat(item.alt_new_issue) || 0,
          stock_before: parseFloat(item.instock) || 0,
          stock_after: parseFloat(item.after_kit) || 0,
          use_alternate: item.use_alt || false,
        }));
      const kitData = {
        store_id: storeG?.store_id,
        date: oDatetime || null,
        kit_status_id: pn2.length > 0 ? 1602 : 1603,
        so_id: formData.so !== "select" ? formData.so.value : null,
        top_part_id: partData.part_id,
        kit_quantity: parseFloat(formData.kit_qty),
        overage: parseFloat(formData.overage),
        complete_date: null,
        notes: formData.notes,
        user_id: userID,
        kit_parts: kitParts,
        kit_alt_parts: kitAltParts,
      };
      const response = await saveKit(kitId, kitData);
      if (response.success) {
        showSuccessToast(
          "Success!",
          `Kit Issued Successfully with Status: Issued - ${pn2.length > 0 ? "Partial" : "Waiting Completion"}`,
        );
        navigate("/Kit");
      } else
        showErrorToast("Error!", "Kit failed to issue!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Kit failed to issue!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleCompleteClick = async (e, type) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    let pn2 = [];
    itemList.forEach((item) => {
      if (item.short < 0) pn2.push(item.part_number);
    });
    altItemList.forEach((item) => {
      if (item.short < 0) pn2.push(item.part_number);
    });
    if (
      type === "Forced" &&
      pn2.length > 0 &&
      !window.confirm(
        `This kit has ${pn2.length} shortages:\n[${pn2.join(", ")}]\n\nAre you sure you want to Force Complete this kit?`,
      )
    ) {
      setLoadBtn(false);
      return;
    }
    if (type !== "Forced" && pn2.length > 0) {
      showErrorToast(
        "Error!",
        `This kit has ${pn2.length} shortages:\n[${pn2.join(", ")}]\n\nYou cannot complete this kit!`,
      );
      setLoadBtn(false);
      return;
    }
    try {
      var now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      const kitId = Part_id >= 10000000 ? 0 : Part_id || 0;
      const kitData = {
        store_id: storeG?.store_id,
        date: oDatetime || null,
        kit_status_id: type === "Forced" ? 1605 : 1604,
        so_id: formData.so !== "select" ? formData.so.value : null,
        top_part_id: partData.part_id,
        kit_quantity: parseFloat(formData.kit_qty),
        overage: parseFloat(formData.overage),
        complete_date: now.toISOString().slice(0, 19).split("T")[0],
        notes: formData.notes,
        user_id: userID,
        kit_parts: [],
        kit_alt_parts: [],
      };
      const response = await saveKit(kitId, kitData);
      if (response.success) {
        showSuccessToast(
          "Success!",
          `Kit Completed Successfully with Status: ${type === "Forced" ? "Forced" : "Kit"} Complete`,
        );
        navigate("/Kit");
      } else
        showErrorToast("Error!", "Kit failed to save!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Kit failed to save!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleCancelClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    if (!window.confirm("Are you sure you want to cancel this kit?")) {
      setLoadBtn(false);
      return;
    }
    if (Part_id >= 10000000) navigate("/Kit");
    try {
      const response = await deleteKitbyId(Part_id);
      if (response.success) {
        showSuccessToast("Success!", "Kit canceled/removed successfully.");
        navigate("/Kit");
      } else
        showErrorToast(
          "Error!",
          "Kit failed to cancel!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Kit failed to cancel!");
    } finally {
      setLoadBtn(false);
    }
  };

  const formatCurrency = (number) => {
    number = number ?? 0;
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (storeG?.store_id && Part_id) {
        setloading(true);
        if (Part_id >= 10000000) {
          var now = new Date();
          now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
          setODatetime(now.toISOString().slice(0, 19).split("T")[0]);
          trackPromise(
            Promise.all([
              GetOpenSOListByStore(storeG.store_id),
              GetPartInvById(Part_id, storeG.store_id),
              getBOMbyPartStore(Part_id, storeG.store_id),
              getBOMAltbyPartStore(Part_id, storeG.store_id),
            ])
              .then(([result0, result1, result2, result3]) => {
                const soOptions = result0.data.map((item) => ({
                  label: `S` + item.so_id,
                  value: item.so_id,
                  sale_date: item.sale_date,
                }));
                setSoIds(soOptions || []);
                setPartData({
                  part_id: result1.data.part_id,
                  part_number: result1.data.part_no,
                  description: result1.data.description,
                  stock: result1.data.unit_instock,
                });
                if (result2.data && result2.data.length > 0) {
                  const partList = result2.data.map((item, i) => ({
                    item_no: i + 1,
                    ref_desc: item.ref_des,
                    dni: item.dni,
                    alt_part_id: item.alternate_part_id,
                    alt_part_number: item.alternate_part_number,
                    alt_part_desc: item.alternate_part_description,
                    category: item.category,
                    location: item.stockroom_location,
                    part_id: item.part_id,
                    part_number: item.part_number,
                    description: item.description,
                    bom: item.bom_str,
                    cost_price: item.cost_price,
                    quantity: item.quantity,
                    unit: item.unit,
                    stock: item.in_stock,
                    instock: item.in_stock + 0,
                    for_kit: 0,
                    for_kit_cost: formatCurrency(0),
                    issued_qty: 0,
                    new_issue: 0,
                    short: 0,
                    after_kit: 0,
                    use_alt: false,
                  }));
                  setItemList(() => [...partList]);
                }
                if (result3.data && result3.data.length > 0) {
                  const apartList = result3.data.map((item, i) => ({
                    item_no: i + 1,
                    ref_desc: item.ref_des,
                    dni: item.dni,
                    alt_part_id: item.alternate_part_id,
                    alt_part_number: item.alternate_part_number,
                    alt_part_desc: item.alternate_part_description,
                    category: item.category,
                    location: item.stockroom_location,
                    part_id: item.part_id,
                    part_number: item.part_number,
                    description: item.description,
                    bom: item.bom_str,
                    cost_price: item.cost_price,
                    quantity: item.quantity,
                    unit: item.unit,
                    stock: item.in_stock,
                    instock: item.in_stock + 0,
                    for_kit: 0,
                    for_kit_cost: formatCurrency(0),
                    issued_qty: 0,
                    alt_new_issue: 0,
                    short: 0,
                    after_kit: 0,
                    use_alt: false,
                  }));
                  setAltItemList(() => [...apartList]);
                }
              })
              .catch((err) => console.log(err.message))
              .finally(() => setloading(false)),
          );
        } else {
          trackPromise(
            Promise.all([
              GetOpenSOListByStore(storeG.store_id),
              getKitbyId(Part_id),
              getKitPartbyId(Part_id),
            ])
              .then(([result0, result1, result2]) => {
                const soOptions = result0.data.map((item) => ({
                  label: `S` + item.so_id,
                  value: item.so_id,
                  sale_date: item.sale_date,
                }));
                setSoIds(soOptions || []);
                setPartData({
                  part_id: result1.data.top_part_id,
                  part_number: result1.data.top_part_no,
                  description: result1.data.top_part_description,
                  stock: result1.data.unit_instock,
                });
                const stId = result1.data.kit_status_id || 1600;
                setODatetime(result1.data.date.split("T")[0] || null);
                setStatus(result1.data.kit_status || "Pending");
                setStatusId(stId);
                const calcQty =
                  result1.data.kit_quantity +
                  (result1.data.kit_quantity * result1.data.overage) / 100;
                let kcost = 0,
                  ccost = 0;
                if (result2.data && result2.data.length > 0) {
                  const partList = result2.data
                    .filter((item) => item.item_no < 10000)
                    .map((item) => {
                      const instk = item.in_stock + (item.issued_quantity || 0);
                      const kQty =
                        item.dni || item.use_alt
                          ? 0
                          : Math.ceil(item.quantity * calcQty) || 0;
                      kcost += item.cost_price * kQty;
                      ccost +=
                        item.cost_price * (kQty - instk > 0 ? kQty - instk : 0);
                      return {
                        item_no: item.item_no,
                        ref_desc: item.ref_des,
                        dni: item.dni,
                        alt_part_id: item.alternate_part_id,
                        alt_part_number: item.alternate_part_number,
                        alt_part_desc: item.alternate_part_description,
                        category: item.category,
                        location: item.stockroom_location,
                        part_id: item.part_id,
                        part_number: item.part_number,
                        description: item.description,
                        bom: item.bom_str,
                        cost_price: item.cost_price || 0,
                        quantity: item.quantity || 0,
                        unit: item.unit,
                        stock: item.in_stock || 0,
                        instock: instk,
                        for_kit: kQty,
                        for_kit_cost: formatCurrency(kQty * item.cost_price),
                        issued_qty: item.issued_quantity || 0,
                        new_issue: 0,
                        short:
                          stId === 1600 || stId === 1601
                            ? instk - kQty < 0
                              ? instk - kQty
                              : 0
                            : (item.issued_quantity || 0) - kQty,
                        after_kit: instk - kQty >= 0 ? instk - kQty : 0,
                        use_alt: item.use_alt || false,
                      };
                    });
                  setItemList(() => [...partList]);
                  const apartList = result2.data
                    .filter((item) => item.item_no >= 10000)
                    .map((item) => {
                      const instk = item.in_stock + (item.issued_quantity || 0);
                      const kQty = !item.use_alt
                        ? 0
                        : Math.ceil(item.quantity * calcQty) || 0;
                      kcost += !item.use_alt ? 0 : item.cost_price * kQty;
                      ccost +=
                        item.cost_price * (kQty - instk > 0 ? kQty - instk : 0);
                      return {
                        item_no: item.item_no - 10000,
                        ref_desc: item.ref_des,
                        dni: item.dni,
                        alt_part_id: item.alternate_part_id,
                        alt_part_number: item.alternate_part_number,
                        alt_part_desc: item.alternate_part_description,
                        category: item.category,
                        location: item.stockroom_location,
                        part_id: item.part_id,
                        part_number: item.part_number,
                        description: item.description,
                        bom: item.bom_str,
                        cost_price: item.cost_price || 0,
                        quantity: item.quantity || 0,
                        unit: item.unit,
                        stock: item.in_stock,
                        instock: instk,
                        for_kit: kQty,
                        for_kit_cost: formatCurrency(kQty * item.cost_price),
                        issued_qty: item.issued_quantity || 0,
                        alt_new_issue: 0,
                        short:
                          stId === 1600 || stId === 1601
                            ? instk - kQty < 0
                              ? instk - kQty
                              : 0
                            : (item.issued_quantity || 0) - kQty,
                        after_kit: instk - kQty >= 0 ? instk - kQty : 0,
                        use_alt: item.use_alt || false,
                      };
                    });
                  setAltItemList(() => [...apartList]);
                }
                setFormData({
                  so: result1.data.so_id
                    ? {
                        label: `S` + result1.data.so_id,
                        value: result1.data.so_id,
                      }
                    : "select",
                  notes: result1.data.notes,
                  kit_qty: result1.data.kit_quantity,
                  overage: result1.data.overage,
                  calc_qty: calcQty,
                  t_cost: kcost,
                  c_cost: ccost,
                });
              })
              .catch((err) => console.log(err.message))
              .finally(() => setloading(false)),
          );
        }
      }
    }
    fetchData();
  }, [storeG, Part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      {(loading || promiseInProgress) && (
        <div className="overlay-freeze">
          <LoadingIndicator />
        </div>
      )}
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={5} className="container-col">
            <Header title="CREATE NEW KIT" />
          </Col>
          <Col md={2} className="container-col">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Kit # {Part_id >= 10000000 ? `New` : Part_id}
            </label>
          </Col>
          <Col md={2} className="container-col">
            <DateInputField
              noGaps={true}
              label="Kit Date:"
              name="kit_date"
              value={oDatetime}
              placeholder="DateTime"
              disabled
              style={{ minWidth: "120px" }}
            />
          </Col>
          <Col md={3} className="container-col text-center">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Kit Status: {status}
            </label>
          </Col>
        </Row>
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <div className="card-sale card-kit">
            <Row xs={1} sm={1}>
              <Col md={3} xl={2} className="container-col">
                <label className="label">
                  Part Number: <span>{partData.part_number}</span>
                </label>
              </Col>
              <Col md={9} xl={6} className="container-col">
                <label className="label">
                  Part Description: <span>{partData.description}</span>
                </label>
              </Col>
              <Col md={12} xl={4} className="container-col">
                <Row>
                  <Col md={3} xl={4} className="container-col">
                    <label className="label">
                      Curr Stk Qty: <span>{partData.stock}</span>
                    </label>
                  </Col>
                  <Col md={3} xl={4} className="container-col">
                    <label className="label">
                      Total Kit Cost:{" "}
                      <span>{formatCurrency(formData.t_cost)}</span>
                    </label>
                  </Col>
                  <Col md={3} xl={4} className="container-col">
                    <label className="label">
                      Complete Cost:{" "}
                      <span>{formatCurrency(formData.c_cost)}</span>
                    </label>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row xs={1} sm={1} className="p-0 mt-2">
              <Col md={2} xl={1} className="container-col">
                <label className="label">Ref SO #:</label>
                <SelectField
                  formField={false}
                  name="so"
                  value={formData.so}
                  options={soIds}
                  onChange={handleSelectChange}
                  placeholder="SO #"
                  error={errors.so}
                  isDisabled={statusId >= 1602}
                />
              </Col>
              <Col md={5} xl={8} className="container-col">
                <label className="label">Misc Note:</label>
                <input
                  type="text"
                  className={"input input-full"}
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Misc Note"
                  disabled={statusId >= 1604}
                />
                {errors?.notes && (
                  <p className="label-error-pos">{errors?.notes}</p>
                )}
              </Col>
              <Col md={2} xl={1} className="container-col">
                <DoubleField
                  label="Kit Qty to Pull:"
                  noGaps={true}
                  name="kit_qty"
                  value={formData.kit_qty}
                  onChange={handleChange}
                  placeholder="Kit Qty"
                  error={errors.kit_qty}
                  disabled={statusId >= 1602}
                />
              </Col>
              <Col md={2} xl={1} className="container-col">
                <DoubleField
                  label="Overage %:"
                  noGaps={true}
                  name="overage"
                  value={formData.overage}
                  onChange={handleChange}
                  placeholder="Overage"
                  error={errors.overage}
                  disabled={statusId >= 1602}
                />
              </Col>
              <Col md={1} xl={1} className="container-col pt-3">
                {statusId === 1601 && (
                  <Button
                    size="md font-semibold"
                    margin="0px"
                    padding="10px"
                    text="FILL"
                    onClick={handleFillClick}
                    disabled={loadBtn}
                  />
                )}
              </Col>
            </Row>
            <Row xs={1} sm={1} className="p-0 mt-2">
              <div className="m-0 p-0 table-container-kit">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="table-sale-tr">
                      <th style={{ width: "28px" }}>#</th>
                      <th style={{ width: "140px" }}>Ref Des</th>
                      <th style={{ width: "30px" }}>DNI</th>
                      <th style={{ width: "90px" }}>Alternate</th>
                      <th style={{ width: "80px" }}>Category</th>
                      <th style={{ width: "140px" }}>Location</th>
                      <th style={{ width: "90px" }}>Child PN</th>
                      <th style={{ width: "320px" }}>Child Description</th>
                      <th style={{ width: "36px" }}>BOM</th>
                      <th style={{ width: "60px" }}>Cost</th>
                      <th style={{ width: "42px" }}>Per Asm</th>
                      <th style={{ width: "55px" }}>UoM</th>
                      <th style={{ width: "42px" }}>In Stk</th>
                      <th style={{ width: "42px" }}>For Kit</th>
                      <th style={{ width: "60px" }}>For Kit Cost</th>
                      <th style={{ width: "45px" }}>Issued Qty</th>
                      <th style={{ width: "64px" }}>New Issue</th>
                      <th style={{ width: "45px" }}>
                        {statusId === 1600 || statusId === 1601
                          ? `Short`
                          : `Short/ Extra`}
                      </th>
                      <th style={{ width: "45px" }}>After Kit</th>
                      <th style={{ width: "32px" }}>Use Alt</th>
                      <th style={{ width: "42px" }}>More Info</th>
                    </tr>
                  </thead>
                  <tbody className="kit-table-body">
                    {itemList?.map((item, index) => (
                      <tr
                        key={index}
                        className={`${rowId === item ? "row-sel" : ""}`}
                        onClick={() => rowSelected(item)}
                      >
                        <td className="text-end">{item.item_no}</td>
                        <td className="text-start">{item.ref_desc}</td>
                        <td className="text-center">{item.dni ? "✔" : "-"}</td>
                        <td className="text-center">{item.alt_part_number}</td>
                        <td className="text-start">{item.category}</td>
                        <td className="text-start">{item.location}</td>
                        <td className="text-center">{item.part_number}</td>
                        <td className="text-start">{item.description}</td>
                        <td className="text-center">{item.bom}</td>
                        <td className="text-end">
                          {formatCurrency(item.cost_price)}
                        </td>
                        <td className="text-center">{item.quantity}</td>
                        <td className="text-center">{item.unit}</td>
                        <td className="text-center">{item.stock}</td>
                        <td className="text-center">{item.for_kit}</td>
                        <td className="text-end">{item.for_kit_cost}</td>
                        <td className="text-center">{item.issued_qty || 0}</td>
                        <td className="text-center">
                          {statusId === 1600 || statusId >= 1604 ? (
                            `${item.new_issue || 0}`
                          ) : (
                            <div className="centered-input-kit">
                              <input
                                className="input"
                                name="new_issue"
                                type="number"
                                step="1.00"
                                min="0"
                                data-index={index}
                                value={item.new_issue}
                                onChange={handleChange}
                              />
                            </div>
                          )}
                        </td>
                        <td className="text-center">{item.short}</td>
                        <td className="text-center">{item.after_kit}</td>
                        <td className="text-center">
                          {item.alt_part_id && !item.dni ? (
                            <input
                              className="align-middle"
                              type="checkbox"
                              data-index={index}
                              name="use_alt"
                              checked={item.use_alt}
                              onChange={handleChange}
                              disabled={statusId >= 1602}
                            />
                          ) : (
                            `-`
                          )}
                        </td>
                        <td className="text-center">NOTE</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Row>
            <Row xs={1} sm={1} className="p-0 mt-2">
              <div className="m-0 p-0 table-container-kit-alt">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="table-sale-tr">
                      <th style={{ width: "28px" }}>#</th>
                      <th style={{ width: "90px" }}>Real PN</th>
                      <th style={{ width: "80px" }}>Category</th>
                      <th style={{ width: "140px" }}>Location</th>
                      <th style={{ width: "90px" }}>Alternate PN</th>
                      <th style={{ width: "320px" }}>Alternate Description</th>
                      <th style={{ width: "36px" }}>BOM</th>
                      <th style={{ width: "60px" }}>Cost</th>
                      <th style={{ width: "42px" }}>Per Asm</th>
                      <th style={{ width: "55px" }}>UoM</th>
                      <th style={{ width: "42px" }}>In Stk</th>
                      <th style={{ width: "42px" }}>For Kit</th>
                      <th style={{ width: "60px" }}>For Kit Cost</th>
                      <th style={{ width: "45px" }}>Issued Qty</th>
                      <th style={{ width: "64px" }}>New Issue</th>
                      <th style={{ width: "45px" }}>
                        {statusId === 1600 || statusId === 1601
                          ? `Short`
                          : `Short/ Extra`}
                      </th>
                      <th style={{ width: "45px" }}>After Kit</th>
                      <th style={{ width: "42px" }}>More Info</th>
                    </tr>
                  </thead>
                  <tbody className="kit-table-body">
                    {altItemList?.map((item, index) => (
                      <tr
                        key={index}
                        className={`${rowId === item ? "row-sel" : ""}`}
                        onClick={() => rowSelected(item)}
                      >
                        <td className="text-end">{item.item_no}</td>
                        <td className="text-center">{item.alt_part_number}</td>
                        <td className="text-start">{item.category}</td>
                        <td className="text-start">{item.location}</td>
                        <td className="text-center">{item.part_number}</td>
                        <td className="text-start">{item.description}</td>
                        <td className="text-center">{item.bom}</td>
                        <td className="text-end">
                          {formatCurrency(item.cost_price)}
                        </td>
                        <td className="text-center">{item.quantity}</td>
                        <td className="text-center">{item.unit}</td>
                        <td className="text-center">{item.stock}</td>
                        <td className="text-center">{item.for_kit}</td>
                        <td className="text-end">{item.for_kit_cost}</td>
                        <td className="text-center">{item.issued_qty || 0}</td>
                        <td className="text-center">
                          {statusId === 1600 || statusId >= 1604 ? (
                            `${item.alt_new_issue || 0}`
                          ) : (
                            <div className="centered-input-kit">
                              <input
                                className="input"
                                name="alt_new_issue"
                                type="number"
                                step="1.00"
                                min="0"
                                data-index={index}
                                value={item.alt_new_issue}
                                onChange={handleChange}
                              />
                            </div>
                          )}
                        </td>
                        <td className="text-center">{item.short}</td>
                        <td className="text-center">{item.after_kit}</td>
                        <td className="text-center">NOTE</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Row>
            <Row className="p-0 mt-4 justify-content-center align-items-center">
              {statusId < 1602 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Save"
                    onClick={(e) => handleSaveClick(e, "Save")}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {statusId < 1602 && Part_id < 10000000 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Cancel Kit"
                    onClick={handleCancelClick}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {statusId < 1601 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Pull Kit"
                    onClick={(e) => handleSaveClick(e, "Pull")}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {statusId === 1601 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Issue Kit"
                    onClick={handleIssueClick}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {(statusId === 1602 || statusId === 1603) && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Issue Item"
                    onClick={handleIssueItemClick}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {statusId === 1603 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Complete Kit"
                    onClick={(e) => handleCompleteClick(e, "Kit")}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {statusId === 1602 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Force Complete"
                    onClick={(e) => handleCompleteClick(e, "Forced")}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {statusId >= 1601 && statusId <= 1603 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Reprint"
                    onClick={handleAddcartClick}
                    disabled={loadBtn}
                  />
                </Col>
              )}
              {Part_id < 10000000 && statusId < 1602 && (
                <Col md="auto p-0">
                  <Button
                    margin="10px"
                    padding="20px"
                    text="Export"
                    onClick={handleAddcartClick}
                    disabled={loadBtn}
                  />
                </Col>
              )}
            </Row>
          </div>
        </Row>
      </Container>
    </div>
  );
};
export default AddEditKit;
